export default "__VITE_ASSET__ef6730dc__"